import Chainable from "@repo/utils/Chainable";
import UArray from "@repo/utils/UArray";

const once = Symbol("once");

namespace UEventTarget {
  export const wrap = <Target extends EventTarget>(eventTarget: Target) => {
    // TODO: Add more mappings
    type EventMap = Target extends Window
      ? WindowEventMap
      : HTMLElementEventMap;

    const on = Chainable.create(
      Chainable.wrapFactory(
        ({
          capture = false,
          passive = false,
          signal = undefined as undefined | AbortSignal,
          once = false,
        }) =>
          <EventType extends keyof EventMap>(
            types: UArray.Maybe<EventType>,
            listener: (this: HTMLElement, e: EventMap[EventType]) => any
          ) => {
            for (const type of [types].flat()) {
              // @ts-expect-error
              eventTarget.addEventListener(type, listener, {
                capture,
                passive,
                signal,
                once,
              });
            }
            return {
              off() {
                for (const type of [types].flat()) {
                  // @ts-expect-error
                  eventTarget.removeEventListener(type, listener);
                }
              },
            };
          }
      ),
      {
        capture: { capture: true },
        passive: { passive: true },
        signal: (signal: AbortSignal) => ({ signal }),
        [once]: { once: true },
      }
    );

    return {
      on,
      get once() {
        return on[once];
      },
    };
  };
}

export default UEventTarget;
